export const getFlagURL = (countryCode: string) =>
  countryCode ? `https://flagcdn.com/${countryCode.toLowerCase()}.svg` : '';
